/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import Axios, { AxiosRequestConfig } from "axios";
// import AuthModel from "@/models/AuthModel";
const axios = Axios.create();
axios.interceptors.request.use((req) => {
  req.baseURL = process.env.VUE_APP_SALUTARIA_API_URL + "/api/auth";
  // req.headers.origin = process.env.BASE_URL;
  return req;
});

export default {
  login(email: string, password: string, firebase_token: string) {
    const formData = new FormData();
    formData.append("email", email);
    formData.append("password", password);
    formData.append("firebase_token", firebase_token);
    const options: AxiosRequestConfig = {
      method: "post",
      url: "/login",
      data: formData,
      headers: {
        "Content-Type": "application/json",
        // "Access-Control-Allow-Origin": "*",
      },
    };
    return axios(options);
  },
  forgetPassword(email: string) {
    const formData = new FormData();
    formData.append("email", email);
    const options: AxiosRequestConfig = {
      method: "post",
      url: "/forget",
      data: formData,
    };
    return axios(options);
  },
  verification(email: string, otp: string) {
    const formData = new FormData();
    formData.append("email", email);
    formData.append("otp", otp);
    const options: AxiosRequestConfig = {
      method: "post",
      url: "/verification",
      data: formData,
    };
    return axios(options);
  },
  resetPassword(
    password: string,
    password_confirm: string,
    jwt_token: string | null
  ) {
    const formData = new FormData();
    formData.append("password", password);
    formData.append("password_confirm", password_confirm);
    const options: AxiosRequestConfig = {
      method: "post",
      url: "/resetpassword",
      data: formData,
      headers: {
        authorization: "Bearer " + jwt_token,
      },
    };
    return axios(options);
  },
};
